import Image from 'next/legacy/image'

import Box from '@totallymoney/ui/components/Box'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'

import totallySureLogo from '../../../../../../public/images/TotallySure-logo.png'
import {
    StyledButton,
    StyledImageContainer,
} from './ScoredCardDetailsTotallySureTooltipBanner.styled'

const ScoredCardDetailsTotallySureTooltipBanner = ({
    onClick,
}: {
    onClick: () => void
}) => (
    <StyledButton
        aria-label="Opens a modal that explains what TotallySure offers means"
        onClick={onClick}
    >
        <Box display="flex" alignItems="center" position="relative" right={0}>
            <Box
                display="flex"
                justifyContent="space-between"
                position="relative"
                py="space10"
                px="space20"
                width={['100%', '95%']}
                borderRadius={[0, 'borderRadius10']}
                backgroundColor="eligibilityLevel0-100"
                flexDirection="row"
            >
                <Box
                    display={['flex', 'none']}
                    alignItems="center"
                    mr="space10"
                >
                    <Image
                        src={totallySureLogo}
                        alt="TotallySure logo"
                        width={90}
                        height={40}
                    />
                </Box>

                <Stack
                    direction="row"
                    justifyContent={['space-between', 'flex-start']}
                    alignItems={['unset', 'center']}
                    space="space10"
                    flex={1}
                >
                    <Stack space={[0, 'space05']} direction={['column', 'row']}>
                        <Text
                            variant="80"
                            color="white"
                            weight="bold"
                            textAlign="left"
                        >
                            Includes pre-approval and guarantees
                        </Text>

                        <Text variant="80" color="white" textAlign="left">
                            (subject to final checks)
                        </Text>
                    </Stack>

                    <Box display="flex" alignSelf="center">
                        <Icon icon="tooltip" size={20} color="white" />
                    </Box>
                </Stack>
            </Box>

            <StyledImageContainer
                display={['none', 'flex']}
                position="absolute"
                right={0}
            >
                <Image
                    src={totallySureLogo}
                    alt="TotallySure logo"
                    width={145}
                    height={64}
                />
            </StyledImageContainer>
        </Box>
    </StyledButton>
)

export default ScoredCardDetailsTotallySureTooltipBanner
